import React, { useMemo, useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Bubble } from 'tea-component';
import GeneralImageNew, { BACKGROUND_IMG_DEFAULT } from '@gp/components/GeneralImageNew';
import './index.scss';

const GamePillarItem = (props: any, ref: any) => {
  const { gamePillar, onClickImgHandle, maxHeight } = props;

  const titleRef = useRef(null);
  const itemTextContentRef = useRef(null);
  const descRef = useRef(null);
  const [isOverflowTitle, setIsOverflowTitle] = useState(false);
  const [showBubbleTitle, setShowBubbleTitle] = useState(false);
  const [isOverflowDesc, setIsOverflowDesc] = useState(false);
  const [showBubbleDesc, setShowBubbleDesc] = useState(false);

  const titleCur = useMemo(() => {
    return gamePillar.title || '';
  }, [gamePillar]);
  const descCur = useMemo(() => {
    return gamePillar.title || '';
  }, [gamePillar]);

  useEffect(() => {
    if (titleRef.current) {
      const element = titleRef.current;
      setIsOverflowTitle(
        element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight,
      );
    }
  }, [titleCur]);

  useEffect(() => {
    if (titleRef.current) {
      const element = titleRef.current;
      setIsOverflowDesc(
        element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight,
      );
    }
  }, [descCur]);

  const handleMouseEnterTitle = () => {
    if (isOverflowTitle) {
      setShowBubbleTitle(true);
    }
  };

  const handleMouseLeaveTitle = () => {
    setShowBubbleTitle(false);
  };

  const handleMouseEnterDesc = () => {
    if (isOverflowDesc) {
      setShowBubbleDesc(true);
    }
  };

  const handleMouseLeaveDesc = () => {
    setShowBubbleDesc(false);
  };

  // 暴露ref给父组件
  useImperativeHandle(ref, () => itemTextContentRef.current as HTMLDivElement);

  return (
    <div ref={itemTextContentRef} className="dbg-game-pillar-data-img">
      <div
        className="dbg-game-pillar-data-text"
        style={{ height: maxHeight && maxHeight !== 0 ? `${maxHeight}px` : undefined }}
      >
        <div
          className="dbg-game-pillar-data-text-title"
          ref={titleRef}
          onMouseEnter={handleMouseEnterTitle}
          onMouseLeave={handleMouseLeaveTitle}
        >
          {gamePillar.title || ''}
          {isOverflowTitle && showBubbleTitle && (
            <Bubble content={titleCur} placement="top">
              <div style={{ display: 'none' }}></div>
            </Bubble>
          )}
        </div>
        <div
          className="dbg-game-pillar-data-text-desc"
          ref={descRef}
          onMouseEnter={handleMouseEnterDesc}
          onMouseLeave={handleMouseLeaveDesc}
        >
          {gamePillar.introduction || ''}
          {isOverflowDesc && showBubbleDesc && (
            <Bubble content={descCur} placement="top">
              <div style={{ display: 'none' }}></div>
            </Bubble>
          )}
        </div>
      </div>
      {gamePillar.cover && (
        <GeneralImageNew
          className="dbg-game-pillar-data-img-new-image"
          domain={'game'}
          errorImg={BACKGROUND_IMG_DEFAULT}
          needBorderRadius={false}
          src={gamePillar.cover || ''}
          onClick={() => {
            onClickImgHandle?.(true);
          }}
        />
      )}
    </div>
  );
};
export default React.forwardRef(GamePillarItem);
